/* OREN — Welle 4: Edition Numbers (sound toggle removed) */
(function(){

  /* ============================================
     EDITION NUMBERS — issued at newsletter signup
     ============================================ */
  const EDITION_KEY = 'oren_edition_id';
  const EDITION_BASE = 24;

  function getOrCreateEditionId(){
    let id = localStorage.getItem(EDITION_KEY);
    if(id) return id;
    return null;
  }

  function assignEditionId(){
    const stored = localStorage.getItem(EDITION_KEY);
    if(stored) return stored;
    const t = Date.now();
    const seq = EDITION_BASE + (t % 9976);
    const id = String(seq).padStart(4, '0');
    localStorage.setItem(EDITION_KEY, id);
    return id;
  }

  function renderEditionBadge(){
    const id = getOrCreateEditionId();
    if(!id) return;
    const footerBottom = document.querySelector('.footer > div:last-child');
    if(!footerBottom) return;
    if(footerBottom.querySelector('.edition-badge')) return;
    const badge = document.createElement('span');
    badge.className = 'edition-badge';
    badge.innerHTML = 'Subscriber <span class="num">' + id + '</span>';
    footerBottom.appendChild(badge);
    requestAnimationFrame(function(){ badge.classList.add('visible'); });
  }

  function watchNewsletterSignup(){
    document.querySelectorAll('form[action*="/contact"], form[action*="#newsletter"], form.newsletter-form').forEach(function(form){
      const tagsInput = form.querySelector('input[name="contact[tags]"]');
      const isNewsletter = tagsInput && /newsletter/i.test(tagsInput.value || '');
      if(!isNewsletter) return;
      form.addEventListener('submit', function(){
        const id = assignEditionId();
        setTimeout(function(){
          showEditionAssignedInline(form, id);
        }, 50);
      });
    });

    const success = document.querySelector('.newsletter-form .form-success, form[action*="/contact"] p, form[action*="#newsletter"] p');
    if(success && /thank|on the list|subscribed/i.test(success.textContent || '')){
      const id = assignEditionId();
      const form = success.closest('form');
      if(form) showEditionAssignedInline(form, id);
    }
  }

  function showEditionAssignedInline(form, id){
    if(form.querySelector('.edition-assigned')) return;
    const block = document.createElement('div');
    block.className = 'edition-assigned';
    block.innerHTML = '<span class="label">Subscriber ID assigned</span>You are <span class="id">' + id + '</span>.<br><span style="opacity:.7;font-size:11px;">Quietly archived. Visible in the footer when you return.</span>';
    form.appendChild(block);
    renderEditionBadge();
  }

  /* ============================================
     CLEANUP — remove any sound toggle that was injected by older versions
     and any cached localStorage from the old sound feature.
     ============================================ */
  function cleanupLegacySoundFeature(){
    try{ localStorage.removeItem('oren_sound_on'); }catch(e){}
    const stale = document.querySelectorAll('.sound-toggle');
    stale.forEach(function(el){ if(el.parentNode) el.parentNode.removeChild(el); });
  }

  function init(){
    cleanupLegacySoundFeature();
    renderEditionBadge();
    watchNewsletterSignup();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
